interface Props{
    width : number,
    height : number,
}

const StopWatch = ({width,height}: Props): React.JSX.Element => {
    return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 20 23">
        <circle cx="9.5" cy="13.5" r="8.5" stroke="#010130" strokeWidth="2" />
        <path stroke="#010130" strokeWidth="2" d="M9.5 8v6M6 2.5l6.5-1v2M16 8l2.5-2" />
    </svg>

}

export default StopWatch
